import http from "@/http/http.js";
let baseURL = "";
if (process.env.NODE_ENV == 'development') {//开发环境
    baseURL = '/api/web/payment/paymentApi/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseURL = '/web/payment/paymentApi/springBoard';
}
// let baseUrl = "/api/payment/paymentApi/getQrCode";

export function paymentApi(params) {
    return http.post(baseURL, {
        actionType: "getQrCode",
        actionBody: {
            uapp_id: "22", //平台渠道ID
            order_num: "TM22202007201510hzO7", //支付单号
            total_fee: "1", //支付金额 分
            body_desc: "自助商标复审", //产品名称
            op_type: "wx", //支付方式 alipay阿里 wx微信
        }
        // actionBody:params
    });
}